(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supra-waitlist"]) return;
  try {
    
  class SupraWaitlist extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      this.embedded = this.dataset.embedded === 'true';
      this.teaser = this.querySelector('[data-waitlist-open]');
      this.editor = this.dataset.editor === 'true';
      this.key = 'supra-waitlist-seen';
      this.successKey = 'supra-waitlist-subscribed';
      try {
        for (const [storage, suffix, destination] of [[sessionStorage, '-waitlist-seen', this.key], [localStorage, '-waitlist-subscribed', this.successKey]]) {
          for (const key of Object.keys(storage)) {
            if (key !== destination && key.endsWith(suffix) && storage.getItem(key) === 'true') {
              storage.setItem(destination, 'true');
              storage.removeItem(key);
            }
          }
        }
      } catch {}
      this.subscribed = false;
      try { this.subscribed = localStorage.getItem(this.successKey) === 'true'; } catch {}
      this.teaser?.addEventListener('click', () => this.open(), options);
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-waitlist-close]')) this.close();
      }, options);
      this.form = this.querySelector('form');
      this.errorMessage = this.querySelector('[data-waitlist-request-error]').textContent;
      this.form.addEventListener('submit', (event) => this.submit(event), options);
      if (this.embedded) {
        if (this.form.querySelector('[data-waitlist-success]')) {
          this.showSuccess();
          const url = new URL(location.href);
          url.searchParams.delete('customer_posted');
          url.hash = '';
          history.replaceState(history.state, '', url.pathname + url.search);
        }
        return;
      }
      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close();
      }, options);
      this.dialog.addEventListener('click', (event) => {
        const bounds = this.dialog.getBoundingClientRect();
        if (event.target === this.dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) this.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        this.unlockPage();
        this.dialog.classList.remove('is-closing');
        this.teaser.hidden = this.subscribed;
        this.remember();
        if (this.previousFocus && this.previousFocus !== document.body && this.previousFocus.isConnected && !this.previousFocus.hidden) this.previousFocus.focus({ preventScroll: true });
        else if (!this.subscribed) this.teaser.focus({ preventScroll: true });
        else {
          const target = document.querySelector('main') || document.body;
          const tabindex = target.getAttribute('tabindex');
          target.setAttribute('tabindex', '-1');
          target.focus({ preventScroll: true });
          if (tabindex === null) target.removeAttribute('tabindex');
          else target.setAttribute('tabindex', tabindex);
        }
      }, options);
      document.addEventListener('touchmove', (event) => {
        if (this.dialog.open && (event.target === this.dialog || !this.dialog.contains(event.target))) event.preventDefault();
      }, { ...options, passive: false });
      document.addEventListener('shopify:section:select', (event) => {
        if (event.detail.sectionId === this.dataset.sectionId) this.open();
      }, options);
      document.addEventListener('shopify:section:deselect', (event) => {
        if (event.detail.sectionId === this.dataset.sectionId) this.close();
      }, options);
      const returnUrl = new URL(location.href);
      const returnedToForm = location.hash === '#' + this.form.id || (returnUrl.searchParams.has('customer_posted') && /waitlist/i.test(location.hash));
      if (returnedToForm) {
        returnUrl.searchParams.delete('customer_posted');
        returnUrl.hash = '';
        history.replaceState(history.state, '', returnUrl.pathname + returnUrl.search);
      }
      const feedback = this.querySelector('[data-waitlist-success], [data-waitlist-error]');
      if (returnedToForm && feedback) {
        if (feedback.hasAttribute('data-waitlist-success')) this.showSuccess();
        this.open();
        this.querySelector('[data-waitlist-success], [data-waitlist-error]')?.focus({ preventScroll: true });
      } else if (this.subscribed && !this.editor) {
        this.teaser.hidden = true;
      } else if (this.editor || this.seen()) {
        this.teaser.hidden = false;
      } else {
        this.timer = setTimeout(() => this.autoOpen(), 3000);
      }
    }
    seen() {
      try { return sessionStorage.getItem(this.key) === 'true'; } catch { return false; }
    }
    async submit(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.submitting || !this.form.reportValidity()) return;
      this.submitting = true;
      const button = this.form.querySelector('[type="submit"]');
      const label = button.textContent;
      const error = this.querySelector('[data-waitlist-request-error]');
      error.textContent = this.errorMessage;
      error.hidden = true;
      this.form.querySelector('[data-waitlist-error]')?.remove();
      button.disabled = true;
      button.textContent = button.dataset.loadingLabel;
      this.form.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(this.form.action, {
          method: 'POST',
          body: new FormData(this.form),
          credentials: 'same-origin',
          headers: { Accept: 'text/html' },
          signal: AbortSignal.any([this.controller.signal, AbortSignal.timeout(20000)]),
        });
        const result = new DOMParser().parseFromString(await response.text(), 'text/html');
        const returnedForm = result.getElementById(this.form.id);
        if (!response.ok || !returnedForm?.querySelector('[data-waitlist-success]')) {
          const returnedError = returnedForm?.querySelector('[data-waitlist-error]');
          if (returnedError) {
            error.textContent = returnedError.textContent;
          } else {
            error.textContent = this.errorMessage;
          }
          throw new Error('Signup was not confirmed');
        }
        this.showSuccess();
      } catch {
        if (this.isConnected) {
          error.hidden = false;
          error.focus({ preventScroll: true });
        }
      } finally {
        this.submitting = false;
        button.disabled = false;
        button.textContent = label;
        this.form.removeAttribute('aria-busy');
      }
    }
    showSuccess() {
      this.querySelector('.supra-waitlist__copy').hidden = true;
      this.querySelector('[data-waitlist-request-error]').hidden = true;
      this.form.replaceChildren(this.querySelector('[data-waitlist-success-template]').content.cloneNode(true));
      if (this.teaser) this.teaser.hidden = true;
      if (!this.editor) {
        this.subscribed = true;
        try { localStorage.setItem(this.successKey, 'true'); } catch {}
      }
      this.form.querySelector('[data-waitlist-success]').focus({ preventScroll: true });
    }
    remember() {
      if (!this.editor) {
        try { sessionStorage.setItem(this.key, 'true'); } catch {}
      }
    }
    autoOpen() {
      if (document.hidden || document.querySelector('dialog[open]') || /\/challenge\/?$/.test(location.pathname)) {
        this.timer = setTimeout(() => this.autoOpen(), 1000);
        return;
      }
      this.open();
    }
    open() {
      clearTimeout(this.timer);
      if (this.dialog.open) return;
      this.previousFocus = document.activeElement;
      this.lockPage();
      this.dialog.showModal();
      this.teaser.hidden = true;
      this.remember();
    }
    lockPage() {
      if (this.pageLock) return;
      const body = document.body;
      const properties = ['position', 'top', 'left', 'width', 'overflow', 'padding-right', 'box-sizing'];
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      const paddingRight = parseFloat(getComputedStyle(body).paddingRight) || 0;
      this.pageLock = {
        x: window.scrollX,
        y: window.scrollY,
        styles: properties.map((name) => [name, body.style.getPropertyValue(name), body.style.getPropertyPriority(name)]),
      };
      const styles = {
        position: 'fixed',
        top: `-${this.pageLock.y}px`,
        left: `-${this.pageLock.x}px`,
        width: '100%',
        overflow: 'hidden',
        'padding-right': `${paddingRight + scrollbarWidth}px`,
        'box-sizing': 'border-box',
      };
      for (const [name, value] of Object.entries(styles)) body.style.setProperty(name, value);
    }
    unlockPage() {
      if (!this.pageLock) return;
      const { x, y, styles } = this.pageLock;
      for (const [name, value, priority] of styles) {
        if (value) document.body.style.setProperty(name, value, priority);
        else document.body.style.removeProperty(name);
      }
      this.pageLock = null;
      window.scrollTo({ left: x, top: y, behavior: 'instant' });
    }
    close() {
      if (!this.dialog.open || this.dialog.classList.contains('is-closing')) return;
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.dialog.close();
        return;
      }
      this.dialog.classList.add('is-closing');
      this.closeTimer = setTimeout(() => this.dialog.close(), 200);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      clearTimeout(this.closeTimer);
      this.controller.abort();
      this.dialog?.close();
      this.unlockPage();
    }
  }
  if (!customElements.get('supra-waitlist')) customElements.define('supra-waitlist', SupraWaitlist);

  } catch(e) { console.error(e); }
})();
})();
